import React, { useContext, useEffect, useState } from "react";
import { ElementState, Preview } from "@creatomate/preview";
import general from "constants/general";
import getTextFontEffect from "components/stories/video-studio/utils/creatomate/getTextFontEffect";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import TextFields from "./TextFields";
import TextOptions from "./TextOptions";
import TextHeader from "./TextHeader";
import { isSubtitleText } from "../subtitle/utils";
import AnimationScreen from "../../animation/AnimationScreen";
import { Context } from "../../animation/AnimationTypes";
import { CreatomateContext } from "../../../contexts/VideoStudioContext";

interface TextProps {
  preview: Preview;
}

const Text: React.FC<TextProps> = ({ preview }) => {
  const { getActiveElement, data: { mediaType } } = useContext(CreatomateContext);
  const activeElement = getActiveElement(preview) as ElementState;
  const { ready, state } = preview;
  const { elements } = state || { elements: [] };
  const [showAnimations, setShowAnimations] = useState(false);
  const [selectedEffect, setSelectedEffect] = useState(general.DEFAULT_EFFECT);
  const isText = activeElement?.source?.type === "text";
  const isMediaTypeVideo = mediaType === VIDEO_TYPE;
  const showTextFields = isText && !isSubtitleText(activeElement?.source?.name);
  const showTextOptions = !showAnimations && !showTextFields;

  useEffect(
    () => {
      if (ready) {
        const textElement = elements.find(
          element => element.source.type === "text" && !isSubtitleText(element.source.name)
        );
        if (textElement
          && (activeElement?.source?.type !== "text" || isSubtitleText(activeElement?.source?.name))) {
          preview.setActiveElements([textElement.source.id]);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready]
  );

  useEffect(
    () => {
      if (isText
        && !isSubtitleText(activeElement?.source?.name)
        && activeElement?.source?.font_family) {
        const effect = getTextFontEffect(activeElement);
        setSelectedEffect(effect);
      }
    }, [activeElement, isText]
  );

  const handleSelectedEffect = (value: string) => setSelectedEffect(value);

  return (
    <>
      <TextHeader
        preview={preview}
        activeElement={activeElement}
        isMediaTypeVideo={isMediaTypeVideo}
        showBackHeader={showAnimations}
        setShowAnimations={setShowAnimations}
        handleSelectedEffect={handleSelectedEffect}
      />

      {showAnimations && (
        <AnimationScreen
          context={Context.Text}
          preview={preview}
          activeElement={activeElement}
        />
      )}

      {!showAnimations && showTextFields && (
        <TextFields
          activeElement={activeElement}
          onSelectedEffect={handleSelectedEffect}
          preview={preview}
          selectedEffect={selectedEffect}
        />
      )}

      {showTextOptions && <TextOptions preview={preview} />}
    </>
  );
};

export default Text;
